export const FETCH_DRIVE_FILES_REQUEST = 'FETCH_DRIVE_FILES_REQUEST';
export const FETCH_DRIVE_FILES_SUCCESS = 'FETCH_DRIVE_FILES_SUCCESS';
export const FETCH_DRIVE_FILES_FAILURE = 'FETCH_DRIVE_FILES_FAILURE';

export const SYNC_DRIVE_FILES_REQUEST = 'SYNC_DRIVE_FILES_REQUEST';
export const SYNC_DRIVE_FILES_SUCCESS = 'SYNC_DRIVE_FILES_SUCCESS';
export const SYNC_DRIVE_FILES_FAILURE = 'SYNC_DRIVE_FILES_FAILURE';

export const CREATE_DRIVE_FOLDER_REQUEST = 'CREATE_DRIVE_FOLDER_REQUEST';
export const CREATE_DRIVE_FOLDER_SUCCESS = 'CREATE_DRIVE_FOLDER_SUCCESS';
export const CREATE_DRIVE_FOLDER_FAILURE = 'CREATE_DRIVE_FOLDER_FAILURE';

